'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Search = require('./Search');

var _Search2 = _interopRequireDefault(_Search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Search2.default;


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-search-field/dist/index.js
// module id = 1397
// module chunks = 0